import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { CsValueApiContext } from "../context/CsValueApiContext";
import { CsValueContext } from "../context/CsValueContext";
import { useCsAttributeApi } from "../hooks/useCsAttributeApi";
/**
 * Wraps value provider and update mechanism for values to the react tree below
 * @category Controller
 * @category CsValue
 */
export function CsValueController({ children, value, }) {
    const { toggleOption: toggle, setValueQuantity } = useCsAttributeApi();
    const valueId = value.value;
    const toggleOption = useCallback((selected) => __awaiter(this, void 0, void 0, function* () {
        yield toggle(valueId, selected);
    }), [toggle, valueId]);
    const setQuantity = useCallback((quantity) => __awaiter(this, void 0, void 0, function* () {
        yield setValueQuantity(valueId, quantity);
    }), [setValueQuantity, valueId]);
    return (_jsx(CsValueContext.Provider, { value: value, children: _jsx(CsValueApiContext.Provider, { value: { toggleOption, setQuantity }, children: children }) }));
}
//# sourceMappingURL=CsValueController.js.map